import React, { useState, useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { brandCarousels, projects } from '../data/projects';
import './Work.css';

const BrandCarousel = ({ brand }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { 
      loop: true, 
      align: 'start',
      skipSnaps: false,
      dragFree: true
    },
    [Autoplay({ delay: 4000, stopOnInteraction: false })]
  );

  const scrollPrev = React.useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = React.useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <div className="brand-carousel-section">
      <div className="brand-header">
        <a 
          href={brand.brandUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="brand-name-link"
        >
          <h2 className="heading-2">{brand.brandName}</h2>
        </a>
        <div className="carousel-controls">
          <button 
            className="carousel-button" 
            onClick={scrollPrev}
            aria-label="Previous"
          >
            <ChevronLeft size={20} />
          </button>
          <button 
            className="carousel-button" 
            onClick={scrollNext}
            aria-label="Next"
          >
            <ChevronRight size={20} />
          </button>
        </div>
      </div>
      <p className="brand-description body-regular">{brand.description}</p>
      
      <div className="embla" ref={emblaRef}>
        <div className="embla__container">
          {brand.images.map((image, index) => (
            <div className="embla__slide" key={index}>
              <img 
                src={image} 
                alt={`${brand.brandName} ${index + 1}`}
                className="carousel-image"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Work = () => {
  return (
    <div className="work">
      <section className="work-hero section-padding">
        <div className="container-narrow">
          <h1 className="heading-1">Work</h1>
          <p className="body-large" style={{ marginTop: '24px' }}>
            A curated selection of campaigns, brand narratives, and visual systems developed 
            across fashion and lifestyle brands.
          </p>
        </div>
      </section>

      {/* Brand Carousels Section */}
      <section className="brands-section section-padding-small">
        <div className="container">
          {brandCarousels.map((brand) => (
            <BrandCarousel key={brand.id} brand={brand} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Work;
